module.exports = __LR__.load("walrus");